// Convert time string to 24-hour format for comparison
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();const timeToMinutes = timeStr => {
    const [time, period] = timeStr.toLowerCase().split(/([ap]m)/);
    let [hours, minutes = 0] = time.split(':').map(Number);

    if (period === 'pm' && hours !== 12) hours += 12;
    if (period === 'am' && hours === 12) hours = 0;

    return hours * 60 + minutes;
};

// Check if current time is within a range
const isTimeInRange = (startTime, endTime) => {
    const now = new Date();
    const currentMinutes = now.getHours() * 60 + now.getMinutes();
    const startMinutes = timeToMinutes(startTime);
    const endMinutes = timeToMinutes(endTime);

    // Handle ranges that cross midnight (e.g., 8pm to 5am)
    if (startMinutes > endMinutes) {
        return currentMinutes >= startMinutes || currentMinutes <= endMinutes;
    }

    return currentMinutes >= startMinutes && currentMinutes <= endMinutes;
};

// Get current appropriate timeOfDay option
export const getCurrentTimeOfDay = () => {
    const now = new Date();
    const dayOfWeek = now.getDay(); // 0 = Sunday, 6 = Saturday
    const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;

    const timeOfDayOptions = Object.entries(contentData.timeOfDay);

    // Find the first time range that matches current time
    for (const [key, data] of timeOfDayOptions) {
        // Skip weekend-only options on weekdays
        if (data.weekendOnly && !isWeekend) {
            continue;
        }

        // Skip breakfast and lunch on weekends if brunch exists
        if (isWeekend && contentData.timeOfDay.brunch) {
            if (key === 'breakfast' || key === 'lunch') {
                continue; // Skip breakfast and lunch on weekends if brunch exists
            }
        }

        if (data.range && isTimeInRange(data.range[0], data.range[1])) {
            return { type: 'timeOfDay', key };
        }
    }

    // Default to breakfast as fallback
    return { type: 'timeOfDay', key: 'breakfast' };
};

// Get weather-based content option
// Accepts locationFallback from LocationContext to avoid redundant API calls
export const getCurrentWeather = async (locationFallback = null) => {
    try {
        // Use provided location from context, otherwise skip weather
        if (!locationFallback?.coordinates) {
            return null;
        }

        const [longitude, latitude] = locationFallback.coordinates;
        const location = `${latitude},${longitude}`;

        // Fetch weather data with timeout (longer than server timeout)
        const response = await Promise.race([
            fetch(`/api/weather?location=${encodeURIComponent(location)}`),
            new Promise(resolve => setTimeout(() => resolve(null), 8000)),
        ]);

        if (!response || !response.ok) {
            return null; // Skip weather if API fails or times out
        }

        const weatherData = await response.json();

        // The API returns category as 'hot', 'cold', or 'justRight'
        if (weatherData.category) {
            return { type: 'weather', key: weatherData.category };
        }

        return null;
    } catch {
        return null; // Skip weather on error
    }
};

export const contentData = {
    favorited: {
        mostFavorited: {
            icon: {
                icon: {
                    url: 'https://images.ctfassets.net/j8tkpy1gjhi5/3PHO9v4vfbjJABD4R46Ysa/1a2c51115dff09941c3133ca2a494bb5/most-favorited.svg',
                },
            },
            headline: `tried,\ntrue and\n treasured`,
        },
    },
    curated: {
        // icon and headline now come from server
    },
    weather: {
        hot: {
            icon: {
                icon: {
                    url: 'https://images.ctfassets.net/j8tkpy1gjhi5/5zPUvUdyb53OuY37cUmwZl/097245ffea062e74b85e917ba24abca2/icon_hot.svg',
                },
            },
            headline: `Sun’s out,\nflavor’s in`,
            filters: ['hot'],
        },
        justRight: {
            icon: {
                icon: {
                    url: 'https://images.ctfassets.net/j8tkpy1gjhi5/2jqki7Tv1DlflHkawRcHdI/d32b7eebf85332bb486f3189f0e65083/trending_icons-temp-justright.svg',
                },
            },
            headline: `Good weather\ncalls for\ngreat food`,
            filters: ['mild'],
        },
        cold: {
            icon: {
                icon: {
                    url: 'https://images.ctfassets.net/j8tkpy1gjhi5/7uLE32uuWTW1kmcdskuFcF/938b107acb825dc7a3cdcd30b0566081/icon_cold.svg',
                },
            },
            headline: `Bundle up\nand\nchow down`,
            filters: ['cold'],
        },
    },
    timeOfDay: {
        breakfast: {
            icon: {
                icon: {
                    url: 'https://images.ctfassets.net/j8tkpy1gjhi5/1qdrr9YKaXm9lzKjhVDPGi/46a54e5fdb31473010e715a0a5530f06/time_of_day.svg',
                },
            },
            headline: `Breakfast\nlovers, this\none’s for you`,
            range: ['6am', '11am'],
            filters: ['breakfast'],
        },
        brunch: {
            icon: {
                icon: {
                    url: 'https://images.ctfassets.net/j8tkpy1gjhi5/1qdrr9YKaXm9lzKjhVDPGi/46a54e5fdb31473010e715a0a5530f06/time_of_day.svg',
                },
            },
            headline: `Brunch without\nthe wait`,
            range: ['6am', '2pm'],
            weekendOnly: true,
            filters: ['brunch'],
        },
        lunch: {
            icon: {
                icon: {
                    url: 'https://images.ctfassets.net/j8tkpy1gjhi5/1qdrr9YKaXm9lzKjhVDPGi/46a54e5fdb31473010e715a0a5530f06/time_of_day.svg',
                },
            },
            headline: `Fuel\nyour\nafternoon`,
            range: ['11am', '2pm'],
            filters: ['lunch'],
        },
        snack: {
            icon: {
                icon: {
                    url: 'https://images.ctfassets.net/j8tkpy1gjhi5/1qdrr9YKaXm9lzKjhVDPGi/46a54e5fdb31473010e715a0a5530f06/time_of_day.svg',
                },
            },
            headline: `Snack like\nnobody’s\nwatching`,
            range: ['2pm', '5pm'],
            filters: ['snack'],
        },
        dinner: {
            icon: {
                icon: {
                    url: 'https://images.ctfassets.net/j8tkpy1gjhi5/1qdrr9YKaXm9lzKjhVDPGi/46a54e5fdb31473010e715a0a5530f06/time_of_day.svg',
                },
            },
            headline: `Flavor that\nbrings everyone\nto the table`,
            range: ['5pm', '8pm'],
            filters: ['dinner'],
        },
        lateSnack: {
            icon: {
                icon: {
                    url: 'https://images.ctfassets.net/j8tkpy1gjhi5/1qdrr9YKaXm9lzKjhVDPGi/46a54e5fdb31473010e715a0a5530f06/time_of_day.svg',
                },
            },
            headline: `The bites\n you dream\nabout`,
            range: ['8pm', '5am'],
            filters: ['snack'],
        },
    },
};

export const loadingMessages = [
    {
        text: `Prepare\nto drool`,
    },
    {
        text: `Cue the\ncravings`,
    },
    {
        text: `So Close\nyou can\ntaste it`,
    },
    {
        text: `*Chews*\nwisely`,
    },
];

// Ordered list of content options for linear cycling
export const orderedContentOptions = [
    { type: 'favorited', key: 'mostFavorited' },
    { type: 'curated', key: null },
    { type: 'weather', key: null }, // Will be determined by current weather
    { type: 'timeOfDay', key: null }, // Will be determined by current time
];
